export function parseEntry({ fields, sys }) {
  const params = Object.keys(fields).reduce((acc, val) => {
    const field = fields[val]
    if (typeof field === 'object' && field?.sys) {
      const { type } = field.sys
      if (type === 'Asset') {
        const file = {
          ...field.fields.file,
          url: `https:${field.fields.file.url}`,
          title: field.fields.title,
        }
        acc[val] = file.url
        acc[`${val}Asset`] = file
      } else if (type === 'Entry') {
        acc[val] = parseEntry(field)
      }
    }

    return acc
  }, {})

  return {
    ...fields,
    ...params,
    contentType: sys.contentType?.sys?.id || null,
    key: sys.id,
    updatedAt:
      fields.customPublishedDate || fields.updatedAt || sys.updatedAt || null,
    createdAt: sys.createdAt || null,
  }
}

export function parseModelsEntries(entries) {
  return entries.items?.map((entry) => parseEntry(entry))
}

export function parsePaginatedEntries(entries, currentPage = 1) {
  return {
    items: parseModelsEntries(entries),
    total: entries.total,
    countOfPages: entries.total ? Math.ceil(entries.total / entries.limit) : 0,
    skip: entries.skip,
    limit: entries.limit,
    currentPage,
  }
}
